/* @ngInject */
const movementFields = (
  movementLabels,
  types,
  icons,
  $$wagon,
  $$railway
) => {
  const self = {}

  self.id = {
    ref: 'id',
    label: movementLabels.fields.id.text,
    icon: icons.id,
    output: false,
  }

  self.nature = {
    ref: 'nature',
    label: movementLabels.fields.nature.text,
    icon: icons.movement.nature,
    output: {
      sortable: true,
      table: { prefill: true, },
      excel: { prefill: true, },
    },
  }

  self.wagonId = {
    ref: 'wagonId',
    label: movementLabels.fields.wagon.text,
    icon: icons.movement.wagon,
    output: {
      sortable: true,
      table: { prefill: true, },
      excel: { prefill: true, },
      class: { 'fix-id': true, },
      link: true,
      go: $$wagon.go.consult,
    },
  }

  self.date = {
    ref: 'date',
    label: movementLabels.fields.date.text,
    icon: icons.movement.date,
    output: {
      sortable: true,
      table: { prefill: true, },
      excel: { prefill: true, },
    },
  }

  self.dateBegin = {
    ref: 'dateBegin',
    label: movementLabels.fields.dateBegin.text,
    icon: icons.movement.date,
    type: types.date,
    output: false,
  }

  self.dateEnd = {
    ref: 'dateEnd',
    label: movementLabels.fields.dateEnd.text,
    icon: icons.movement.date,
    type: types.date,
    output: false,
  }

  self.departureRailway = {
    ref: 'departureRailway',
    label: movementLabels.fields.departureRailway.text,
    icon: icons.movement.departureRailway,
    output: {
      sortable: true,
      table: { prefill: true, },
      excel: { prefill: true, },
      link: true,
      go: $$railway.go.consult,
    },
  }

  self.departurePosition = {
    ref: 'departurePosition',
    label: movementLabels.fields.departurePosition.text,
    icon: icons.movement.departurePosition,
    output: {
      sortable: true,
      table: { prefill: true, },
      excel: { prefill: true, },
    },
  }

  self.arrivalRailway = {
    ref: 'arrivalRailway',
    label: movementLabels.fields.arrivalRailway.text,
    icon: icons.movement.arrivalRailway,
    output: {
      sortable: true,
      table: { prefill: true, },
      excel: { prefill: true, },
      link: true,
      go: $$railway.go.consult,
    },
  }
  self.arrivalPosition = {
    ref: 'arrivalPosition',
    label: movementLabels.fields.arrivalPosition.text,
    icon: icons.movement.arrivalPosition,
    output: {
      sortable: true,
      table: { prefill: true, },
      excel: { prefill: true, },
    },
  }

  return self
}
export default movementFields



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/trains/movement/resources/fields.resource.js